/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types -- ControlValueAccessor interface*/
/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import { AfterViewInit, Component, ElementRef, forwardRef, Input, OnChanges, OnDestroy, ViewChild } from "@angular/core";
import {
  AbstractControl,
  ControlValueAccessor,
  NG_VALIDATORS,
  NG_VALUE_ACCESSOR,
  UntypedFormControl,
  ValidationErrors,
  Validator,
} from "@angular/forms";
import { MatCheckboxChange } from "@angular/material/checkbox";
import { Utility } from "@ignite/ignite-common";
import { Subject, takeUntil, tap } from "rxjs";

@Component({
  selector: "ignite-name",
  templateUrl: "./ignite-name.component.html",
  styleUrls: ["./ignite-name.component.scss"],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => IgniteNameComponent),
      multi: true,
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => IgniteNameComponent),
      multi: true,
    },
  ],
  standalone: false,
})
export class IgniteNameComponent implements AfterViewInit, OnDestroy, ControlValueAccessor, OnChanges, Validator {
  static readonly NO_NAME_VALUE = ".";
  static nextId = 0;
  unsubscribe$: Subject<void> = new Subject<void>();
  hasNoName = false;
  showCheckbox = false;
  isSurname = true;

  @Input() id: string;
  @Input() label: string;
  @Input() hint = "";
  @Input() enterOnBehalfOf = "Myself";
  @Input() placeholder: string;
  @Input() nameControl: UntypedFormControl;
  @Input() category: "surname" | "given-names" = "surname";

  @ViewChild("inputControl") inputControl: ElementRef<HTMLElement>;
  @ViewChild("noName") noName: ElementRef<HTMLElement>;

  public onTouched: () => void = () => {
    // do nothing
  };

  ngAfterViewInit(): void {
    this.isSurname = this.category === "surname";
    let wrapper: any = this.inputControl.nativeElement.closest(".mat-mdc-form-field");
    if (!Utility.IsNull(wrapper) && !Utility.IsNull(this.noName)) {
      wrapper = wrapper.getElementsByClassName("mat-mdc-form-field-subscript-wrapper");
      if (wrapper.length > 0) {
        wrapper[0].appendChild(this.noName.nativeElement);
      }
    }
    if (!Utility.IsNull(this.nameControl)) {
      this.showCheckbox = this.nameControl.enabled;
      if (this.nameControl.value === IgniteNameComponent.NO_NAME_VALUE) {
        this.hasNoName = true;
      }
      this.nameControl.valueChanges
        .pipe(
          takeUntil(this.unsubscribe$),
          tap((value: string) => {
            if (!this.nameControl.dirty) {
              this.showCheckbox = this.nameControl.enabled;
            }
            if (value === IgniteNameComponent.NO_NAME_VALUE) {
              this.hasNoName = true;
              this.nameControl.parent?.updateValueAndValidity({ emitEvent: false });
              if (this.nameControl.valid) {
                this.nameControl.disable({ emitEvent: false });
              }
            }
          })
        )
        .subscribe();
    }
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  ngOnChanges(changes): void {
    if (this.nameControl) {
      this.nameControl.updateValueAndValidity({ emitEvent: true });
    }
  }

  isEmpty(): boolean {
    return Utility.IsEmptyOrNull(this.nameControl.value);
  }

  writeValue(val: any): void {
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
    val && this.nameControl.setValue(val, { emitEvent: true });
  }

  registerOnChange(fn: any): void {
    this.nameControl.valueChanges.pipe(takeUntil(this.unsubscribe$)).subscribe(fn);
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    if (isDisabled) {
      this.nameControl.disable();
    } else {
      this.nameControl.enable();
    }
  }

  validate(control: AbstractControl): ValidationErrors | null {
    return this.nameControl.valid ? null : this.nameControl.errors;
  }

  onNoNameChanged($event: MatCheckboxChange): void {
    this.nameControl.markAsDirty();
    if ($event.checked) {
      this.nameControl.setValue(".");
      if (this.nameControl.valid) {
        this.nameControl.disable();
      }
    } else {
      this.nameControl.setValue("");
      this.nameControl.enable();
      setTimeout(() => this.inputControl.nativeElement.focus(), 100);
    }
  }
}
